import InviteEmployeesModal from '@web/users/InviteUsers/InviteEmployeesModal';

export default {
  ReactComponent: InviteEmployeesModal,
  bindings: {
    currentUser: '<',
    locations: '<',
    addPersonaCollectionUser: '&',
    setShouldOpenInviteEmployeesModal: '&',
    shouldOpenInviteEmployeesModal: '<',
  },
};
